import { useState, useEffect } from 'react';

const Loader = ({ onLoadingComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onLoadingComplete) {
        onLoadingComplete();
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);


  return (
<div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/90">
      <div className="relative w-16 h-16 mb-6">
        <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-[#c9a962] rounded-full animate-spin"></div>
      </div>
      <div className="text-center">
        <h1 className="text-2xl md:text-3xl font-serif font-bold text-[#1a3a5c] mb-2">
          AKY Legal Consultants
        </h1>
<p className="text-gray-700 text-sm tracking-widest uppercase">
          Excellence in Legal Solutions
        </p>
      </div>
    </div>
  );
};

export default Loader;
